export default class DesktopSlider {
	_rootDiv;
	_rootDivSelector;
	_data;
	_state;
	constructor(
		sourceObjectsArray,
		rootDiv,
		rootDivSelector = "",
		slidesShown = 4,
		currentMainImageIndex = 0,
		currentBottomSliderImageIndex = 0
	) {
		this._sourceObjectsArray = sourceObjectsArray;
		this._rootDiv = rootDiv;
		this._rootDivSelector = rootDivSelector;
		this._data = {
			sourceObjectsArray: sourceObjectsArray,
			slidesShown: slidesShown,
		};
		this._state = {
			currentMainImageIndex: currentMainImageIndex,
			currentBottomSliderImageIndex: currentBottomSliderImageIndex,
		};
	}

	// getters

	get sourceObjectsArray() {
		return this._data.sourceObjectsArray;
	}
	get rootDiv() {
		return this._rootDiv;
	}
	get rootDivSelector() {
		return this._rootDivSelector;
	}

	// setters

	set sourceObjectsArray(sourceObjectsArray) {
		this._data.sourceObjectsArray = sourceObjectsArray;
	}
	set rootDiv(rootDiv) {
		this._rootDiv = rootDiv;
	}
	set rootDivSelector(rootDivSelector) {
		this._rootDivSelector = rootDivSelector;
	}

	// html template

	_getSliderHTML() {
		// IMPORTANT ADDED d-none to buttons of main image
		return `
            <div class="main-popup-img position-relative d-flex align-items-center justify-content-center h-100 w-100 d-flex">
                <img class="" src="" alt="${window.lihe.name} - ${window.lihe.station}" style="object-fit: cover; width: 100%; height: 100%;">
                <button
                    style="width: 30px; height: 30px; border-radius: 50%; padding: 5px; background: rgba(255, 255, 255, 0.8);"
                    class="main-popup-img-controls cursor-pointer position-absolute left d-flex justify-content-center align-items-center d-none"
                >
                    <svg color="#52B3D8" width="18" height="18" class="icon">
                        <use xlink:href="#___icon___chevron-left"></use>
                    </svg>
                </button>
                <button
                    style="width: 30px; height: 30px; border-radius: 50%; padding: 5px; background: rgba(255, 255, 255, 0.8);"
                    class="main-popup-img-controls cursor-pointer position-absolute right d-flex justify-content-center align-items-center d-none"
                >
                    <svg color="#52B3D8" width="18" height="18" class="icon">
                        <use xlink:href="#___icon___chevron-right"></use>
                    </svg>
                </button>

            </div>
            <div class="popup-prestation-slider-desktop position-relative overflow-hidden h-100">
                <button
                    class="slider-btn-desktop cursor-pointer position-absolute left justify-content-center align-items-center"
                >
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.4028 9.75L12.3222 15L17.4028 20.25" stroke="#0042B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="-1" y="1" width="27.0323" height="28" rx="13.5161" transform="matrix(-1 0 0 1 27.7417 0)" stroke="#0042B8" stroke-width="2"/>
                </svg>
                
                </button>
                <button
                    class="slider-btn-desktop cursor-pointer position-absolute right justify-content-center align-items-center"
                >
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.6294 20.25L17.71 15L12.6294 9.75" stroke="#0042B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="1" y="-1" width="27.0323" height="28" rx="13.5161" transform="matrix(1 0 0 -1 0.290527 28)" stroke="#0042B8" stroke-width="2"/>
                </svg>
                
                </button>


                <div class="popup-prestation-image-list animate d-flex flex-row nowrap" style="position: absolute; left: 0px; height: 100%;">

                </div>
            </div>
        `;
	}

	// private methods

	_populateBottomSliderList() {
		const sliderList = this._getBottomSliderList();
		sliderList.innerHTML = "";
		this._data.sourceObjectsArray.forEach((obj, i) => {
			sliderList.insertAdjacentHTML(
				"beforeend",
				`
            <div class="popup-prestation-image-wrapper cursor-pointer" style="border-radius: 7px; overflow: hidden;">
                <img class="w-100 h-100 popup-prestation-image" ${
									i >= this._data.slidesShown ? 'loading="lazy"' : ""
								} src="${obj.imgMedium}" alt="${window.lihe.name} - ${
					window.lihe.station
				}">
            </div>
            `
			);
		});
	}

	_getSlider() {
		return this._getRootDiv().querySelector(".popup-prestation-slider-desktop");
	}
	_getBottomSliderList() {
		return this._getRootDiv().querySelector(".popup-prestation-image-list");
	}
	_getImgWidth() {
		return (
			parseFloat(window.getComputedStyle(this._getSlider()).width) /
			this._data.slidesShown
		);
	}
	_getImgHeight() {
		return this._getBottomSliderList().firstElementChild.getBoundingClientRect()
			.height;
	}
	_getMainImg() {
		return this._getRootDiv().querySelector(".main-popup-img img");
	}
	_injectHTML() {
		this._getRootDiv().innerHTML = "";
		this._getRootDiv().insertAdjacentHTML("beforeend", this._getSliderHTML());
	}
	_getRootDiv() {
		return this._rootDiv
			? this._rootDiv
			: document.querySelector(this._rootDivSelector);
	}

	_animateToImage_bottomSlider(imgNo) {
		this._getBottomSliderList().style.left = `-${
			parseFloat(this._getImgWidth()) * imgNo
		}px`;
	}

	_setMainImage(i) {
		this._getMainImg().src = this._data.sourceObjectsArray[i].imgXL;
		this._state.currentMainImageIndex = i;
		this._setBottomImageShadow();
	}

	_getNextImgNo(currentImageNo, direction) {
		if (direction === "left") {
			const preliminaryToImage = currentImageNo - 1;
			let newImgNo = preliminaryToImage;
			if (preliminaryToImage < 0) {
				newImgNo = this._data.sourceObjectsArray.length - 1;
			}
			return newImgNo;
		} else if (direction === "right") {
			const preliminaryToImage = currentImageNo + 1;
			let newImgNo = preliminaryToImage;
			if (preliminaryToImage >= this._data.sourceObjectsArray.length) {
				newImgNo = 0;
			}
			return newImgNo;
		}
	}

	_setListeners() {
		Array.from(this._getBottomSliderList().children).forEach((img, i) => {
			img.addEventListener("click", () => {
				this._setMainImage(i);
			});
		});

		["left", "right"].forEach((direction) => {
			// top slider click
			this._getRootDiv()
				.querySelector(`.main-popup-img-controls.${direction}`)
				.addEventListener("click", () => {
					let newImgNo = this._getNextImgNo(
						this._state.currentMainImageIndex,
						direction
					);
					if (
						newImgNo >
						this._data.sourceObjectsArray.length - this._data.slidesShown
					) {
						this._animateToImage_bottomSlider(
							this._data.sourceObjectsArray.length - this._data.slidesShown
						);
						this._state.currentBottomSliderImageIndex =
							this._data.sourceObjectsArray.length - this._data.slidesShown;
					} else {
						this._animateToImage_bottomSlider(newImgNo);
						this._state.currentBottomSliderImageIndex = newImgNo;
					}
					this._setMainImage(newImgNo);
				});

			// bottom slider click
			this._getRootDiv()
				.querySelector(`.slider-btn-desktop.${direction}`)
				.addEventListener("click", () => {
					let newImgNo = this._getNextImgNo(
						this._state.currentBottomSliderImageIndex,
						direction
					);
					if (
						direction === "right" &&
						newImgNo >
							this._data.sourceObjectsArray.length - this._data.slidesShown
					) {
						newImgNo = 0;
					}
					if (
						direction === "left" &&
						newImgNo >
							this._data.sourceObjectsArray.length - this._data.slidesShown
					) {
						newImgNo =
							this._data.sourceObjectsArray.length - this._data.slidesShown;
					}
					this._animateToImage_bottomSlider(newImgNo);
					this._state.currentBottomSliderImageIndex = newImgNo;
				});
		});

		this._getBottomSliderList()
			.querySelector("img")
			.addEventListener("load", () => {
				// on first img load - adjust width and height
				this.adjust();
			});
	}

	_setBottomImageShadow() {
		const imageWrappersArray = Array.from(
			this._getSlider().querySelectorAll(".popup-prestation-image-wrapper")
		);
		imageWrappersArray.forEach((wrapper, wrapper_i) => {
			if (wrapper_i === this._state.currentMainImageIndex) {
				wrapper.classList.add("active");
			} else {
				wrapper.classList.remove("active");
			}
		});
	}

	_adjustSliderHeight() {
		this._getSlider().style.height = `${this._getImgHeight() + 4}px`;
		this._getSlider().style.maxHeight = `${this._getImgHeight() + 4}px`;
	}

	_adjustImageWidth() {
		const neededWidth =
			parseFloat(this._getSlider().getBoundingClientRect().width) /
			this._data.slidesShown;
		Array.from(
			this._getSlider().querySelectorAll(".popup-prestation-image-wrapper")
		).forEach((img) => {
			img.style.width = `${neededWidth}px`;
		});
	}

	// public methods
	init() {
		this._injectHTML();
		this._populateBottomSliderList();
		this._setMainImage(0);
		this._setListeners();
		if (this._data.slidesShown >= this._data.sourceObjectsArray.length) {
			// hide lower slider arrows if not enough images
			this._rootDiv.querySelectorAll(".slider-btn-desktop").forEach((el) => {
				el.style.display = "none";
			});
		}
		this.adjust();
	}

	adjust() {
		this._adjustSliderHeight();
		this._adjustImageWidth();
	}
}
